import { matchPath } from 'react-router-dom';

import { orderDetailsPageRoutePath } from '~/routes/order-details-page/orderDetailsPageRoute.path';

import { type OrderDetailsPageRoute } from '../types/orderDetailsPageScanSubmit.type';

interface OrderDetailsPageRouteParams {
  batchEntryId?: string;
  orderId: string;
}

const matchOrderDetailsPageRoute = (rawPath?: string) => {
  if (!rawPath) return undefined;

  return matchPath<OrderDetailsPageRouteParams>(rawPath, {
    exact: true,
    path: orderDetailsPageRoutePath,
  });
};

export const resolveDisplayedOrderDetailsOrderId = (rawPath?: string): string | undefined =>
  matchOrderDetailsPageRoute(rawPath)?.params.orderId;

export const resolveOrderDetailsPageRoute = (
  rawPath?: string,
): OrderDetailsPageRoute | undefined => {
  const match = matchOrderDetailsPageRoute(rawPath);

  // The shared path also matches an order without a shipment; scans need the batch entry.
  if (!match?.params.batchEntryId) return undefined;

  return { batchEntryId: match.params.batchEntryId, orderObjectId: match.params.orderId };
};
